// ══════════════════════════════════════════════════════════════════════════════
// SELDOR — i18n Translations (Arabic / English)
// ══════════════════════════════════════════════════════════════════════════════

export const translations = {
  ar: {
    dir: 'rtl',
    // Branding
    brandName: 'سيلدور',
    tagline: 'اختيار الأبواب الصحيحة يفتح لك أبواب النمو',
    // Auth
    welcome: 'مرحبًا بعودتك',
    signInPrompt: 'سجّل الدخول للمتابعة',
    email: 'البريد الإلكتروني',
    password: 'كلمة المرور',
    signIn: 'تسجيل الدخول',
    signingIn: 'جاري التحقق...',
    invalidCredentials: 'البريد أو كلمة المرور غير صحيحة',
    accessRestricted: 'الوصول مقيّد. تواصل مع المسؤول.',
    signOut: 'تسجيل الخروج',
    // Roles
    superAdmin: 'المسؤول الأعلى',
    owner: 'المالك',
    manager: 'المدير',
    employee: 'موظف',
    accountant: 'المحاسب',
    customer: 'العميل',
    // Navigation (4 Pillars)
    dashboard: 'لوحة القيادة',
    insightHub: 'مركز الرؤى',
    marketIntel: 'ذكاء السوق',
    growthRoadmap: 'خارطة النمو',
    financialRadar: 'الرادار المالي',
    // Admin nav
    commandCenter: 'مركز التحكم',
    userManagement: 'إدارة المستخدمين',
    tenantManagement: 'إدارة العملاء',
    broadcast: 'الإشعارات',
    customerOverride: 'الدخول كعميل',
    switchMode: 'تبديل الوضع',
    adminMode: 'وضع الإدارة',
    clientMode: 'وضع العميل',
    // Theme / Lang
    darkMode: 'الوضع الداكن',
    lightMode: 'الوضع الفاتح',
    arabic: 'العربية',
    english: 'English',
    // Dashboard
    businessOverview: 'نظرة عامة على الأعمال',
    last30Days: 'آخر 30 يومًا',
    totalRevenue: 'إجمالي الإيرادات',
    netProfit: 'صافي الربح',
    wasteLeakage: 'الهدر والتسرّب',
    processEfficiency: 'كفاءة العمليات',
    activeGaps: 'فجوات نشطة',
    openInsights: 'رؤى مفتوحة',
    potentialSavings: 'مدخرات محتملة',
    revenueTrend: 'اتجاه الإيرادات',
    topProducts: 'أعلى المنتجات ربحية',
    branchPerformance: 'أداء الفروع',
    viewDetails: 'عرض التفاصيل',
    back: 'رجوع',
    // Drill-downs
    wasteTitle: 'تحليل الهدر والتسرّب',
    wasteDesc: 'تحليل الفجوة بين الإيرادات المتوقعة والفعلية',
    profitTitle: 'تحليل صافي الربح',
    profitDesc: 'تفصيل مصادر الربح والمصروفات',
    expectedRevenue: 'الإيرادات المتوقعة',
    actualRevenue: 'الإيرادات الفعلية',
    leakageRate: 'نسبة التسرّب',
    expenseBreakdown: 'توزيع المصروفات',
    grossMargin: 'هامش الربح الإجمالي',
    // Insight Hub
    insightHubTitle: 'مركز الرؤى التشغيلية',
    insightHubDesc: 'توصيات عملية مبنية على تحليل بياناتك',
    whyThis: 'لماذا هذه المشكلة؟',
    howToFix: 'كيف تحلها؟',
    expectedImpact: 'الأثر المتوقع',
    aiGenerated: 'مولّد بالذكاء الاصطناعي',
    ruleBased: 'تحليل قياسي',
    dismiss: 'تجاهل',
    markResolved: 'تم الحل',
    newAnalysis: 'تحليل جديد',
    noInsights: 'لا توجد رؤى حالياً',
    noInsightsDesc: 'عملياتك تسير بشكل طبيعي',
    // Insight types
    insightType_fraud: 'كفاءة العمليات',
    insightType_waste: 'هدر',
    insightType_pricing: 'تسعير',
    insightType_staffing: 'توظيف',
    insightType_opportunity: 'فرصة',
    insightType_customer_pattern: 'سلوك العملاء',
    insightType_inventory: 'مخزون',
    insightType_financial: 'مالي',
    insightType_operational: 'تشغيلي',
    insightType_marketing: 'تسويق',
    // Severity
    severity_critical: 'حرج',
    severity_warning: 'تنبيه',
    severity_info: 'معلومة',
    severity_high: 'عالي',
    severity_medium: 'متوسط',
    severity_low: 'منخفض',
    // Market Intel
    marketIntelTitle: 'ذكاء السوق',
    marketIntelDesc: 'أسعار السوق في الرياض مقارنة بأسعارك',
    material: 'المادة',
    marketPrice: 'سعر السوق',
    yourPrice: 'سعرك',
    difference: 'الفرق',
    status: 'الحالة',
    statusGood: 'ممتاز',
    statusOverpay: 'تدفع أكثر',
    priceTrend: 'اتجاه الأسعار',
    perKg: '/كغ',
    // Growth Roadmap
    growthRoadmapTitle: 'خارطة النمو',
    growthRoadmapDesc: 'خارطتك من الأساس إلى الهدف النهائي',
    goal: 'الهدف',
    currentProgress: 'التقدم الحالي',
    goalOf: 'من',
    milestones: 'الإنجازات',
    levelFoundation: 'الأساس',
    levelGrowth: 'النمو',
    levelScale: 'التوسع',
    levelMastery: 'الإتقان',
    levelUltimate: 'الهدف النهائي',
    autoDetected: 'تم اكتشافه تلقائياً',
    markManually: 'وضع علامة يدوياً',
    completed: 'مكتمل',
    // Financial Radar
    financialRadarTitle: 'الرادار المالي',
    financialRadarDesc: 'كشف النزيف التشغيلي — الفجوات بين المتوقع والفعلي',
    expectedValue: 'المتوقع',
    actualValue: 'الفعلي',
    gapAmount: 'الفجوة',
    gapInventory: 'فجوة مخزون',
    gapRevenue: 'فجوة إيرادات',
    gapCost: 'فجوة تكلفة',
    resolveGap: 'معالجة',
    leakDetected: 'نزيف مكتشف',
    noGaps: 'لا فجوات مكتشفة',
    noGapsDesc: 'بياناتك المالية متطابقة مع التوقعات',
    estimatedLoss: 'الخسارة المتوقعة',
    // Admin
    totalUsers: 'المستخدمون',
    activeUsers: 'النشطون',
    totalTenants: 'العملاء',
    alerts: 'تنبيهات',
    uploadsToday: 'ملفات اليوم',
    createUser: 'إنشاء مستخدم',
    createTenant: 'إنشاء عميل',
    editUser: 'تعديل المستخدم',
    editTenant: 'تعديل العميل',
    searchUsers: 'بحث...',
    fullName: 'الاسم الكامل',
    tenant: 'العميل',
    role: 'المنصب',
    phone: 'الهاتف',
    lastLogin: 'آخر دخول',
    actions: 'الإجراءات',
    never: 'لم يدخل',
    active: 'نشط',
    inactive: 'معطّل',
    accountActive: 'الحساب نشط',
    assignTenant: 'تعيين العميل',
    passwordHint: 'كلمة المرور (اتركها فارغة للإبقاء)',
    // Tenant feature flags
    modulesActive: 'وحدات نشطة',
    // Actions
    save: 'حفظ',
    saved: 'تم الحفظ!',
    cancel: 'إلغاء',
    create: 'إنشاء',
    update: 'تحديث',
    delete: 'حذف',
    edit: 'تعديل',
    add: 'إضافة',
    confirm: 'تأكيد',
    submit: 'إرسال',
    retry: 'إعادة المحاولة',
    refresh: 'تحديث',
    download: 'تحميل',
    upload: 'رفع',
    export: 'تصدير',
    none: '— لا يوجد —',
    // States
    loading: 'جاري التحميل...',
    loadingData: 'جاري تحميل البيانات...',
    noData: 'لا توجد بيانات',
    noDataYet: 'لا توجد بيانات بعد',
    noDataDesc: 'ابدأ برفع بياناتك لرؤية التحليلات.',
    error: 'خطأ',
    errorOccurred: 'حدث خطأ',
    // Broadcast
    composeMessage: 'كتابة إشعار',
    messageTitle: 'العنوان',
    messageBody: 'النص',
    scopeGlobal: 'شامل — الجميع',
    scopeByRole: 'حسب الدور',
    scopeSpecific: 'مستخدم محدد',
    send: 'إرسال',
    sent: 'تم الإرسال!',
    recentBroadcasts: 'الإشعارات الأخيرة',
    noNotifications: 'لا توجد إشعارات',
    // Admin override
    enterDashboard: 'دخول اللوحة',
    exitOverride: 'خروج من وضع المسؤول',
    adminOverrideBar: 'وضع المسؤول — عرض لوحة',
    // Currency
    sar: 'ر.س',
    // Misc
    flagged: 'مُبلَّغ',
    clear: 'نظيف',
    profit: 'الربح',
    cost: 'التكلفة',
    locked: 'مقفل',
    lockedDesc: 'هذه الخاصية غير مفعّلة في اشتراكك الحالي.',
    upgradeRequest: 'طلب ترقية',
    // Modules labels (for feature flags)
    module_dashboard: 'لوحة القيادة',
    module_insight_hub: 'مركز الرؤى',
    module_market_intel: 'ذكاء السوق',
    module_growth_roadmap: 'خارطة النمو',
    module_financial_radar: 'الرادار المالي',
    // Data Mapping
    dataMapping: 'ربط البيانات',
    dataMappingTitle: 'ربط أسماء المواد',
    dataMappingDesc: 'اربط الأسماء غير المعيارية في فواتيرك بكتالوج سيلدور القياسي',
    pendingMappings: 'ربط معلّق',
    confirmedMappings: 'ربط مؤكد',
    rawInput: 'الإدخال الأصلي',
    suggestedMatch: 'الاقتراح',
    matchScore: 'نسبة التطابق',
    confirmMatch: 'تأكيد',
    rejectMatch: 'رفض',
    manualMap: 'اختيار يدوي',
    selectCanonical: 'اختر المادة المقابلة',
    noSuggestions: 'لا توجد اقتراحات',
    occurrences: 'تكرار',
    autoMatched: 'مطابقة تلقائية',
    highConfidence: 'ثقة عالية',
    mediumConfidence: 'ثقة متوسطة',
    lowConfidence: 'ثقة منخفضة',
    testMapping: 'اختبر الربط',
    testMappingDesc: 'اكتب اسماً لترى كيف سيحلّه النظام',
    // Marketing insights
    insightType_marketing: 'تسويق',
    // Labor cost
    laborCost: 'تكلفة العمالة',
    laborEfficiency: 'كفاءة العمالة',
    revenuePerLaborSAR: 'إيراد لكل ريال عمالة',
    unprofitableShift: 'وردية خاسرة',
    // Operational buffer
    operationalBuffer: 'الهامش التشغيلي',
    staffConsumption: 'استهلاك الموظفين',
    wasteTolerance: 'هامش الهدر الطبيعي',
    adjustedGap: 'الفجوة بعد الخصم',
    // Savings calculator
    potentialMonthlySavings: 'وفر شهري محتمل',
    totalPotentialSavings: 'إجمالي الوفر المحتمل',
    savingsCalcDetail: 'تفاصيل الحساب',
    monthlyConsumption: 'الاستهلاك الشهري',
    priceDifference: 'فرق السعر',
    annualSavings: 'وفر سنوي',
    // Growth Tree Gating
    treeView: 'عرض الشجرة',
    listView: 'عرض القائمة',
    syncMetrics: 'تحديث المقاييس',
    syncing: 'جاري التحديث...',
    metricsSynced: 'تم التحديث',
    consecutiveMonths: 'سلسلة الشهور',
    readyToComplete: 'مستعد للإكمال',
    milestoneInProgress: 'قيد التنفيذ',
    milestoneLocked: 'مقفل',
    gateReasonParent: 'يتطلب إكمال المرحلة السابقة',
    gateReasonStreak: 'يحتاج شهور متتالية بالهدف',
    // Summary cards
    completedMilestones: 'مكتملة',
    readyMilestones: 'جاهزة',
    inProgressMilestones: 'قيد التنفيذ',
    lockedMilestones: 'مقفلة'
  },
  en: {
    dir: 'ltr',
    brandName: 'SELDOR',
    tagline: 'Choose the right doors, and growth will follow',
    welcome: 'Welcome back',
    signInPrompt: 'Sign in to continue',
    email: 'Email',
    password: 'Password',
    signIn: 'Sign In',
    signingIn: 'Authenticating...',
    invalidCredentials: 'Invalid email or password',
    accessRestricted: 'Access restricted. Contact your administrator.',
    signOut: 'Sign Out',
    superAdmin: 'Super Admin',
    owner: 'Owner',
    manager: 'Manager',
    employee: 'Employee',
    accountant: 'Accountant',
    customer: 'Customer',
    dashboard: 'Dashboard',
    insightHub: 'Insight Hub',
    marketIntel: 'Market Intel',
    growthRoadmap: 'Growth Roadmap',
    financialRadar: 'Financial Radar',
    commandCenter: 'Command Center',
    userManagement: 'User Management',
    tenantManagement: 'Tenant Management',
    broadcast: 'Broadcast',
    customerOverride: 'Customer Override',
    switchMode: 'Switch Mode',
    adminMode: 'Admin Mode',
    clientMode: 'Client Mode',
    darkMode: 'Dark Mode',
    lightMode: 'Light Mode',
    arabic: 'العربية',
    english: 'English',
    businessOverview: 'Business Overview',
    last30Days: 'Last 30 days',
    totalRevenue: 'Total Revenue',
    netProfit: 'Net Profit',
    wasteLeakage: 'Waste & Leakage',
    processEfficiency: 'Process Efficiency',
    activeGaps: 'Active Gaps',
    openInsights: 'Open Insights',
    potentialSavings: 'Potential Savings',
    revenueTrend: 'Revenue Trend',
    topProducts: 'Top Profitable Products',
    branchPerformance: 'Branch Performance',
    viewDetails: 'View Details',
    back: 'Back',
    wasteTitle: 'Waste & Leakage Analysis',
    wasteDesc: 'Gap analysis between expected and actual revenue',
    profitTitle: 'Net Profit Analysis',
    profitDesc: 'Breakdown of profit sources and expenses',
    expectedRevenue: 'Expected Revenue',
    actualRevenue: 'Actual Revenue',
    leakageRate: 'Leakage Rate',
    expenseBreakdown: 'Expense Breakdown',
    grossMargin: 'Gross Margin',
    insightHubTitle: 'Operational Insight Hub',
    insightHubDesc: 'Data-driven recommendations from your analytics',
    whyThis: 'Why this issue?',
    howToFix: 'How to fix it?',
    expectedImpact: 'Expected Impact',
    aiGenerated: 'AI-generated',
    ruleBased: 'Standard Analysis',
    dismiss: 'Dismiss',
    markResolved: 'Mark Resolved',
    newAnalysis: 'New Analysis',
    noInsights: 'No insights right now',
    noInsightsDesc: 'Your operations look healthy',
    insightType_fraud: 'Process Efficiency',
    insightType_waste: 'Waste',
    insightType_pricing: 'Pricing',
    insightType_staffing: 'Staffing',
    insightType_opportunity: 'Opportunity',
    insightType_customer_pattern: 'Customer Pattern',
    insightType_inventory: 'Inventory',
    insightType_financial: 'Financial',
    insightType_operational: 'Operational',
    insightType_marketing: 'Marketing',
    severity_critical: 'Critical',
    severity_warning: 'Warning',
    severity_info: 'Info',
    severity_high: 'High',
    severity_medium: 'Medium',
    severity_low: 'Low',
    marketIntelTitle: 'Market Intelligence',
    marketIntelDesc: 'Riyadh market prices vs your prices',
    material: 'Material',
    marketPrice: 'Market Price',
    yourPrice: 'Your Price',
    difference: 'Difference',
    status: 'Status',
    statusGood: 'Good',
    statusOverpay: 'Overpaying',
    priceTrend: 'Price Trend',
    perKg: '/kg',
    growthRoadmapTitle: 'Growth Roadmap',
    growthRoadmapDesc: 'Your path from foundation to ultimate goal',
    goal: 'Goal',
    currentProgress: 'Current Progress',
    goalOf: 'of',
    milestones: 'Milestones',
    levelFoundation: 'Foundation',
    levelGrowth: 'Growth',
    levelScale: 'Scale',
    levelMastery: 'Mastery',
    levelUltimate: 'Ultimate Goal',
    autoDetected: 'Auto-detected',
    markManually: 'Mark manually',
    completed: 'Completed',
    financialRadarTitle: 'Financial Radar',
    financialRadarDesc: 'Operational leak detection — gaps between expected and actual',
    expectedValue: 'Expected',
    actualValue: 'Actual',
    gapAmount: 'Gap',
    gapInventory: 'Inventory Gap',
    gapRevenue: 'Revenue Gap',
    gapCost: 'Cost Gap',
    resolveGap: 'Resolve',
    leakDetected: 'Leak Detected',
    noGaps: 'No gaps detected',
    noGapsDesc: 'Your financials match expectations',
    estimatedLoss: 'Estimated Loss',
    totalUsers: 'Total Users',
    activeUsers: 'Active Users',
    totalTenants: 'Tenants',
    alerts: 'alerts',
    uploadsToday: 'Uploads Today',
    createUser: 'Create User',
    createTenant: 'Create Tenant',
    editUser: 'Edit User',
    editTenant: 'Edit Tenant',
    searchUsers: 'Search users...',
    fullName: 'Full Name',
    tenant: 'Tenant',
    role: 'Role',
    phone: 'Phone',
    lastLogin: 'Last Login',
    actions: 'Actions',
    never: 'Never',
    active: 'Active',
    inactive: 'Inactive',
    accountActive: 'Account Active',
    assignTenant: 'Assign Tenant',
    passwordHint: 'Password (leave blank to keep)',
    modulesActive: 'modules active',
    save: 'Save',
    saved: 'Saved!',
    cancel: 'Cancel',
    create: 'Create',
    update: 'Update',
    delete: 'Delete',
    edit: 'Edit',
    add: 'Add',
    confirm: 'Confirm',
    submit: 'Submit',
    retry: 'Retry',
    refresh: 'Refresh',
    download: 'Download',
    upload: 'Upload',
    export: 'Export',
    none: '— None —',
    loading: 'Loading...',
    loadingData: 'Loading data...',
    noData: 'No data',
    noDataYet: 'No data yet',
    noDataDesc: 'Upload your data to start seeing analytics.',
    error: 'Error',
    errorOccurred: 'An error occurred',
    composeMessage: 'Compose Message',
    messageTitle: 'Title',
    messageBody: 'Message',
    scopeGlobal: 'Global — All',
    scopeByRole: 'By Role',
    scopeSpecific: 'Specific User',
    send: 'Send',
    sent: 'Sent!',
    recentBroadcasts: 'Recent Broadcasts',
    noNotifications: 'No notifications',
    enterDashboard: 'Enter Dashboard',
    exitOverride: 'Exit Admin Override',
    adminOverrideBar: 'Admin Override — Viewing as',
    sar: 'SAR',
    flagged: 'FLAGGED',
    clear: 'Clear',
    profit: 'Profit',
    cost: 'Cost',
    locked: 'Locked',
    lockedDesc: 'This feature is not enabled in your subscription.',
    upgradeRequest: 'Request Upgrade',
    module_dashboard: 'Dashboard',
    module_insight_hub: 'Insight Hub',
    module_market_intel: 'Market Intel',
    module_growth_roadmap: 'Growth Roadmap',
    module_financial_radar: 'Financial Radar',
    // Data Mapping
    dataMapping: 'Data Mapping',
    dataMappingTitle: 'Material Name Mapping',
    dataMappingDesc: 'Map non-standard names in your invoices to the Seldor canonical catalog',
    pendingMappings: 'Pending Mappings',
    confirmedMappings: 'Confirmed Mappings',
    rawInput: 'Raw Input',
    suggestedMatch: 'Suggestion',
    matchScore: 'Match Score',
    confirmMatch: 'Confirm',
    rejectMatch: 'Reject',
    manualMap: 'Manual Map',
    selectCanonical: 'Select canonical material',
    noSuggestions: 'No suggestions',
    occurrences: 'occurrences',
    autoMatched: 'Auto-matched',
    highConfidence: 'High confidence',
    mediumConfidence: 'Medium confidence',
    lowConfidence: 'Low confidence',
    testMapping: 'Test Mapping',
    testMappingDesc: 'Type a name to see how the system resolves it',
    // Marketing insights
    insightType_marketing: 'Marketing',
    // Labor cost
    laborCost: 'Labor Cost',
    laborEfficiency: 'Labor Efficiency',
    revenuePerLaborSAR: 'Revenue per labor SAR',
    unprofitableShift: 'Unprofitable Shift',
    // Operational buffer
    operationalBuffer: 'Operational Buffer',
    staffConsumption: 'Staff Consumption',
    wasteTolerance: 'Waste Tolerance',
    adjustedGap: 'Gap after buffer',
    // Savings calculator
    potentialMonthlySavings: 'Potential Monthly Savings',
    totalPotentialSavings: 'Total Potential Savings',
    savingsCalcDetail: 'Calculation Details',
    monthlyConsumption: 'Monthly Consumption',
    priceDifference: 'Price Difference',
    annualSavings: 'Annual Savings',
    // Growth Tree Gating
    treeView: 'Tree View',
    listView: 'List View',
    syncMetrics: 'Sync Metrics',
    syncing: 'Syncing...',
    metricsSynced: 'Synced',
    consecutiveMonths: 'Consecutive months',
    readyToComplete: 'Ready to complete',
    milestoneInProgress: 'In progress',
    milestoneLocked: 'Locked',
    gateReasonParent: 'Requires parent milestone',
    gateReasonStreak: 'Needs consecutive months at target',
    // Summary cards
    completedMilestones: 'Completed',
    readyMilestones: 'Ready',
    inProgressMilestones: 'In Progress',
    lockedMilestones: 'Locked'
  }
};

export const getTranslations = (lang) => translations[lang] || translations.ar;
